/**
 * (De)serialización de filtros de animales en query-string, para que el chatbot
 * pueda abrir "Mi Ganado" con un filtro compartible (modo 'filtro' de ChatAction).
 * Los arrays se serializan como claves repetidas (?estado=A&estado=B), igual que
 * espera/produce el objeto `filters` de AnimalesPage.
 */

export interface AnimalFiltersQS {
  searchTerm?: string;
  estado?: string[];
  raza?: string[];
  categoria?: string[];
  tipoEdad?: string[];
  esComprado?: string[];
  prenies?: string[];
  unidad?: string[];
  ubicacion?: string[];
  renspa?: string[];
}

const ARRAY_KEYS = ['estado', 'raza', 'categoria', 'tipoEdad', 'esComprado', 'prenies', 'unidad', 'ubicacion', 'renspa'] as const;
type ArrayKey = (typeof ARRAY_KEYS)[number];

export function parseFiltersFromSearchParams(sp: URLSearchParams): AnimalFiltersQS {
  const f: AnimalFiltersQS = {};
  const search = sp.get('searchTerm');
  if (search) f.searchTerm = search;
  for (const k of ARRAY_KEYS) {
    const vals = sp.getAll(k);
    if (vals.length) f[k] = vals;
  }
  return f;
}

export function buildSearchParamsFromFilters(f: AnimalFiltersQS): URLSearchParams {
  const sp = new URLSearchParams();
  if (f.searchTerm) sp.set('searchTerm', f.searchTerm);
  for (const k of ARRAY_KEYS) {
    for (const v of f[k] || []) sp.append(k, v);
  }
  return sp;
}

export function hasFilters(f: AnimalFiltersQS): boolean {
  return !!f.searchTerm || ARRAY_KEYS.some((k) => (f[k] || []).length > 0);
}

export function mergeFilters<T extends Record<string, unknown>>(base: T, patch: AnimalFiltersQS): T & AnimalFiltersQS {
  return { ...base, ...patch } as T & AnimalFiltersQS;
}

export type { ArrayKey };
